.submit {
    max-width: 400px;
}